import { Message } from 'element-ui';

/**
 * 值是否不为空
 */
export const isNotNull = val => {
    return !isNull(val);
}
/**
 * 值是否为空
 */
export const isNull = val => {
    if(val == '0'){
        return false;
    }
    if (val == null || val == undefined || val.length == 0 || val == 'undefined' || val == 'null') {
        return true;
    }
    if (val == "") {
        return true;
    }
    return false;
}
/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
    const keyValueArr = url.split('?')[1].split('&')
    let paramObj = {}
    keyValueArr.forEach(item => {
        const keyValue = item.split('=')
        paramObj[keyValue[0]] = keyValue[1]
    })
    return paramObj
}

/**
 * 检查是否是日期格式
 */
export const checkDate = str => {
    if (isNull(str)) {
        return false;
    }
    var date = /^(\d{4})-(\d{2})-(\d{2})$/
    var time = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    let r1 = str.match(date);
    let r2 = str.match(time);
    if (r1 == null && r2 == null) {
        return false;
    }
    if (r2 != null) {
        var d = new Date(r2[1], r2[3] - 1, r2[4], r2[5], r2[6], r2[7]);
        return (d.getFullYear() == r2[1] && (d.getMonth() + 1) == r2[3] && d.getDate() == r2[4] && d.getHours() == r2[5] && d.getMinutes() == r2[6] && d.getSeconds() == r2[7]);
    } else if (r1 != null) {
        var d = new Date(r[1], r[3] - 1, r[4]);
        return (d.getFullYear() == r1[1] && (d.getMonth() + 1) == r1[3] && d.getDate() == r1[4]);
    }
}

/**
 * 字符串转日期
 */
export const toDate = str => {
    if (isNull(str)) {
        return null;
    }
    var date = /^(\d{4})-(\d{2})-(\d{2})$/;
    var time = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    let r1 = str.match(date);
    let r2 = str.match(time);
    if (r1 == null && r2 == null) {
        return null;
    }
    if (r2 != null) {
        return new Date(r2[1], r2[3] - 1, r2[4], r2[5], r2[6], r2[7]);
    } else if (r1 != null) {
        return new Date(r[1], r[3] - 1, r[4]);
    }
}

/**
 * 时间戳转字符串
 */
export const formatDate = (dateline, formdate) => {
    dateline = dateline;
    if (dateline == null || dateline == '') {
        return '';
    }
    // new Date('');传入毫秒数,也可以得到普通的时间,再对date处理
    var date = new Date(parseInt(dateline));
    //获取年份,月份,天数,小时数,分钟数,小于10的显示01-09
    var year = date.getFullYear();
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    if (formdate == null || formdate == "yyyy-mm-dd HH:mm:ss") {
        return year + "-" + month + "-" + currentDate + " " + hours + ":" + minutes + ":" + second;
    } else if (formdate == "yyyy-mm-dd") {
        return year + "-" + month + "-" + currentDate;
    } else if (formdate == "yyyy-mm") {
        return year + month;
    } else if (formdate == "mm-dd") {
        return month + "-" + currentDate;
    } else if (formdate == "HH:mm") {
        return hours + ":" + minutes;
    } else if (formdate == "HH:mm:ss") {
        return hours + ":" + minutes+":"+second;
    } else {
        return "";
    }
}

/**
 * 字符串日期更换格式
 */
export const formatDate1 = (dateStr, formdate) => {
    if (isNull(dateStr) || !checkDate(dateStr)) {
        return '';
    }
    let date = toDate(dateStr).getTime()
    return formatDate(date, formdate)
}

/**
 * 检查是否是double数字
 */
export const checkDouble = str => {
    if(isNaN(str)){
        return false;
    }else if(str.indexOf("-")>=0){
        return false;
    }else if(str.indexOf(".")>0){
        var t = str.split(".");
        if(t[1].length>2){
            return false;
        }
    }
    return true;
}

/**
 * 检查手机号格式
 */
export const checkMobile = str => {
    var mobile_check = /^1\d{10}$/i;
    return mobile_check.test(str);
}

/**
 * 检查邮箱格式
 */
export const checkMail = str =>{
    var mailreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    if(!mailreg.test(str)){
        return false;
    }
    return true;
}

/**
 * 警告消息
 */
export const msg = msg => {
    Message.error({
        showClose: true,
        message: msg
    })
}

/**
 * 成功消息
 */
export const msgs = msg => {
    Message.success({
        showClose: true,
        message: msg
    })
}

/**
 * 是否包含中文
 */
export const hasZh = str => {
    var zh_check = /[\u4e00-\u9fa5]/;
    return zh_check.test(str);
}

/**
 * 身份证中获取生日
 */
export const getBirthDayByID = idCard =>{
    var birthday = "";
	if(idCard != null && idCard != ""){
		if(idCard.length == 15){
			birthday = "19"+idCard.substr(6,6);
		} else if(idCard.length == 18){
			birthday = idCard.substr(6,8);
		}
		birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
	}
	return birthday;
}
/**
 * 身份证中获取性别
 */
export const getSexByID = idCard =>{
    if(parseInt(idCard.charAt(16)/2)*2!=idCard.charAt(16))
        return 1;
    else
        return 0;
}


//检查身份证格式是否正确
var vcity = {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
    21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏",
    33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南",
    42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆",
    51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃",
    63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
};
export const checkIdentity = (card) => {
    //是否为空
    if (card === '') {
        return '身份证号不能为空';
    }
    //校验长度，类型
    if (isCardNo(card) === false) {
        return '身份证号长度错误';
    }
    //检查省份
    if (checkProvince(card) === false) {
        return '身份证校验错误';
    }
    //校验生日
    if (checkBirthday(card) === false) {
        return '身份证生日格式错误';
    }
    //检验位的检测
    if (checkParity(card) === false) {
        return '身份证校验位错误';
    }
    return '';
};


//检查号码是否符合规范，包括长度，类型
function isCardNo(card) {
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
    if (reg.test(card) === false) {
        return false;
    }

    return true;
};

//取身份证前两位,校验省份
function checkProvince(card) {
    var province = card.substr(0, 2);
    if (vcity[province] == undefined) {
        return false;
    }
    return true;
};

//检查生日是否正确
function checkBirthday(card) {
    var len = card.length;
    //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len == '15') {
        var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
        var arr_data = card.match(re_fifteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date('19' + year + '/' + month + '/' + day);
        return verifyBirthday('19' + year, month, day, birthday);
    }
    //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len == '18') {
        var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arr_data = card.match(re_eighteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date(year + '/' + month + '/' + day);
        return verifyBirthday(year, month, day, birthday);
    }
    return false;
};

//校验日期
function verifyBirthday(year, month, day, birthday) {
    var now = new Date();
    var now_year = now.getFullYear();
    //年月日是否合理
    if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
        //判断年份的范围（0岁到150岁之间)
        var time = now_year - year;
        if (time >= 0 && time <= 150) {
            return true;
        }
        return false;
    }
    return false;
};

//校验位的检测
function checkParity(card) {
    //15位转18位
    card = changeFivteenToEighteen(card);
    var len = card.length;
    if (len == '18') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0, i, valnum;
        for (i = 0; i < 17; i++) {
            cardTemp += card.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[cardTemp % 11];
        if (valnum == card.substr(17, 1).toUpperCase()) {
            return true;
        }
        return false;
    }
    return false;
};

//15位转18位身份证号
function changeFivteenToEighteen(card) {
    if (card.length == '15') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0, i;
        card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
        for (i = 0; i < 17; i++) {
            cardTemp += card.substr(i, 1) * arrInt[i];
        }
        card += arrCh[cardTemp % 11];
        return card;
    }
    return card;
};

//生成唯一UUID
export const generateUUID = () => {
    var d = new Date().getTime();

    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}